import "./__styles__/PropertyForm.scss";
import React, { useState } from "react";
import { useModal } from "react-modal-hook";
import {
  ButtonSection,
  Container,
  ContentSection,
  HeaderSection,
  PrimaryButtons,
} from "../Common/__styles__/Modal";
import { Button } from "../Common/Buttons/Button";
import Modal from "../Common/Modal";
import { SelectionCard } from "../Inputs/SelectionCard";

interface SelectAddressProps {
  suggestedAddress: string;
  fullAddress: string;
  onSelect: (selectedAddress: string) => void;
  onCancel: () => void;
}

export type SelectAddressUseModalProps = Omit<SelectAddressProps, "onCancel">;

export default () => {
  const [props, setProps] = useState<Maybe<SelectAddressUseModalProps>>(null);

  const [show, hide] = useModal(() => {
    return (
      <Modal onRequestClose={hide}>
        <SelectAddressModal onCancel={hide} {...props!} />
      </Modal>
    );
  }, [props]);

  const showWithProps = (props: SelectAddressUseModalProps) => {
    setProps(props);
    show();
  };

  return [showWithProps, hide] as const;
};

export const SelectAddressModal = ({
  suggestedAddress,
  fullAddress,
  onSelect,
  onCancel,
}: SelectAddressProps) => {
  const [selectedAddress, setSelectedAddress] = useState(suggestedAddress);
  return (
    <Container data-testid="select-address-modal">
      <HeaderSection>
        <h1>Confirm address</h1>
        <h2>Review the recommended changes and make a selection</h2>
      </HeaderSection>
      <ContentSection
        css={{
          "& p": {
            margin: "0",
          },
        }}
      >
        <SelectionCard.Group
          direction="horizontal"
          spacing="default"
          currentValue={selectedAddress}
          handleSelection={setSelectedAddress}
        >
          <SelectionCard.Item
            key="user-provided"
            value={fullAddress}
            borderStyle="outline"
            size="default"
          >
            <SelectionCard.CommonContent
              title="You entered"
              description={fullAddress}
            />
          </SelectionCard.Item>
          <SelectionCard.Item
            key="suggested"
            value={suggestedAddress}
            borderStyle="outline"
            size="default"
          >
            <SelectionCard.CommonContent
              title="Standardized address"
              description={suggestedAddress}
            />
          </SelectionCard.Item>
        </SelectionCard.Group>
      </ContentSection>
      <ButtonSection>
        <PrimaryButtons>
          <Button
            variant="secondary"
            size="medium"
            onPress={onCancel}
            title="Cancel"
          />
          <Button
            type="submit"
            variant="primary"
            size="medium"
            onPress={() => {
              onSelect(selectedAddress);
            }}
            title="Save"
          />
        </PrimaryButtons>
      </ButtonSection>
    </Container>
  );
};
